export { default as Autocomplete } from './Autocomplete';
export type { OptionType, AutocompleteProps } from './Autocomplete'; // Export types
